import React from 'react';
import './index.css';

interface TabItem {
    label: string,
    onClick: Function,
    active?: boolean,
    hidden?: boolean,
    alertball?: boolean

}
interface Props {
    vertical?: boolean,
    items: TabItem[]
}

const TabMenu: React.FC<Props> = (props) => {

    return (
        <div className={`tabmenu${props.vertical ? ' vertical' : ''}`}>
            <div className="left">
                {
                    props.items.length > 0 &&
                    props.items.map((item, index) => {

                        return (
                            !item.hidden &&
                            <span key={index} className={`item${(item.active) ? ' active' : ''}`} onClick={event => item.onClick(event)} >
                                {
                                    props.vertical &&
                                    <div className="tag" />
                                }
                                <div className='tab'>
                                    {item.label}
                                    {
                                        item.alertball &&
                                        <div className="alertBall"></div>
                                    }
                                </div>
                                {
                                    !props.vertical &&
                                    <div className="tag" />
                                }
                            </span>
                        )
                    })
                }
            </div>
            <div className="right">
                {props.children}
            </div>
        </div>
    );
}

export default TabMenu;